import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlaySound = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 500,
	height: 500,
	viewBox: "0 0 75 75",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M39.389 13.769L22.235 28.606H6v19.093h15.989l17.4 15.051V13.769z",
		strokeWidth: 5,
		fill: "#333",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M48 27.6A19.5 19.5 0 0148 49m7.1-28.5a30 30 0 010 35.6M61.6 14a38.8 38.8 0 010 48.6",
		fill: "none",
		stroke: "#BBB",
		strokeWidth: 5,
		strokeLinecap: "round"
	})]
});
export default SvgPlaySound;
